<template>
  <div class="home">
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'Home',
  mounted(){
    location.href = "https://kurand.jp/pages/404";
  }
}
</script>